import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBxcZjSWYhOATrw07J_IhLU5c1-R-ZBfUs",
  authDomain: "mata-codes.firebaseapp.com",
  projectId: "mata-codes",
  storageBucket: "mata-codes.appspot.com",
  messagingSenderId: "668989516490",
  appId: "1:668989516490:web:a381e55d8814a8e7b8e233",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
